export const isMobileMixin = {
    data() {
        return {
            isMobile: window.innerWidth < 800
        }
    },

    mounted() {
        window.addEventListener('resize', this.documentResizeHandler)
    },

    methods: {
        documentResizeHandler() {
            // console.log('onResize')
            this.isMobile = window.innerWidth < 800
        }
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.documentResizeHandler)
    }
}

export const textFieldsValidations = {
    data() {
        return {
            validations: {
                required: value => !!value || 'Required.',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Required an e-mail.'
                },
                minLength: value => value.length > 5 || 'Min length of password is 5 characters.'
            },
        }
    }
}